import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { SettingsService } from './settings.service';
import { LoggerService } from './logger.service';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { ACCESS } from 'app/original-models/access.model';
import { ALL_USER_ID, COLORS_COUNT, SYSTEM_USER_ID, SYSTEM_USER_NAME, SYSTEM_USER_SHORT } from 'app/common/constants';
import {StorageService} from './storage.service';
import {TeamMember} from '../original-models/team-member.model';

@Injectable({ providedIn: 'root' })
export class TeamMembersCacheService {
    apiUrl: string;
    private _getMembersSubject = new BehaviorSubject<any>(null);
    private _initialized = false;

    static getMappedMembers(result, companyId, allUsersText) {
        let users = [];
        let members = [];
        if (result && result.count > 0 && result.results?.length) {

            let systemUserId = `${SYSTEM_USER_ID}-${companyId}`;
            members.push( { persistent_id: systemUserId, text: SYSTEM_USER_NAME, email: SYSTEM_USER_NAME});

            users[systemUserId] = {
                email: SYSTEM_USER_NAME,
                fullName: SYSTEM_USER_NAME,
                shortName: SYSTEM_USER_SHORT,
                color: SYSTEM_USER_ID,
                member_id: 0
              };

            result.results.forEach(user => {
                if (result.results.filter(u => u.email === user.email).length > 1 && (user.groups.length ? user.groups[0].name : '') === ACCESS.GroupManager) {
                    return;
                }
                let fullName = `${user.first_name} ${user.last_name}`;
                users[`${user.persistent_id}`] = {
                    email: user.email,
                    fullName: fullName,
                    shortName: `${user.first_name.substring(0, 1)}${user.last_name.substring(0, 2)}`.toUpperCase(),
                    color: user.persistent_id.includes('owner') && !user.groups.length ? 'owner' : user.id % COLORS_COUNT,
                    member_id: user.id
                };
                members.push({ persistent_id: user.persistent_id, text: fullName, email: user.email,
                     order: user.groups.length ? Object.values(ACCESS).indexOf(user.groups[0].name) : 0});
            });
            members = members.sort((a, b) => a.order - b.order);
            members.unshift({persistent_id: ALL_USER_ID, text: allUsersText, email: allUsersText})
            return {members: members, users: users};
        } else {
            return null;
        }
    }

    constructor(
        public http: HttpClient,
        private settings: SettingsService,
        private logger: LoggerService,
        private storage: StorageService
    ) {
        this.apiUrl = this.settings.apiUrl;
    }

    getMembers(refresh?: boolean): Observable<any> {
        let area = this.storage.getArea();
        if (!area) {
            return of(null);
        }
        let areaKey = `${area.key}/${area.id}`;
        if (area && (refresh || !this._initialized || !this._getMembersSubject?.value || this._getMembersSubject.value.key !== areaKey)) {
            this._initialized = true;
            this._getMembersSubject = new BehaviorSubject<any>(
                null
            );
            return this.fetchMembers().pipe(
                map((value) => {
                   if (value) {
                        value.key = areaKey;
                        this._getMembersSubject.next(value);
                    }
                    return value;
                })
            );
        } else {
            return this._getMembersSubject.asObservable();
        }
    }

    fetchMembers(): Observable<any> {
        let area = this.storage.getArea();
        if (!area?.key || !area?.id) {
            return of(null);
        }
        return this.http
            .get(`${this.apiUrl}/${area.key}/${area.id}/members/`)
            .pipe(
                map((response: any) => {
                    response.results = response.results.map((item) => {
                        return new TeamMember().setFromApiModel(item);
                    });
                    return response;
                }),
                catchError((error) => {
                    this.logger.error(error);
                    return of(false);
                })
            );
    }

    getCurrentMember(refresh?: boolean) {
        return this.getMembers(refresh).pipe(
            map((users) => {
                if (users && users.results && users.count > 0) {
                    let currentRoles = users.results.filter(u => u.email === this.storage.userEmail);
                    if (currentRoles.length === 1) {
                        return currentRoles[0];
                    } else {
                        return currentRoles.find(user =>
                            (user.groups.length ? user.groups[0].name : '') !== ACCESS.GroupManager)
                    }

                } else {
                    return null;
                }
            }
        ));
    }
}
